// extracted by mini-css-extract-plugin
export var actions = "_7w-5";
export var item = "_7w-2";
export var price = "_7w-4";
export var quantity = "_7w-3";
export var sku = "_7w-1";
export var table = "_7w-0";